/* Size chart: move the trigger next to the SIZE label, open a simple modal. */
(function () {
  if (window.__mkSizeChart) return;
  window.__mkSizeChart = true;

  function place() {
    document.querySelectorAll('[data-mk-sc]').forEach(function (wrap) {
      if (wrap.getAttribute('data-placed') === '1') return;
      var opt = document.querySelector('.t4s-swatch__option.is-t4s-name__size');
      var btn = wrap.querySelector('[data-mk-sc-open]');
      if (!opt || !btn) return;
      opt.classList.add('mk-sc-host');
      opt.appendChild(btn);
      // portal the modal to <body>: inside the product block an ancestor
      // stacking context traps it under the Sale badge
      var modal = wrap.querySelector('[data-mk-sc-modal]');
      if (modal && modal.parentNode !== document.body) document.body.appendChild(modal);
      wrap.removeAttribute('hidden');
      wrap.setAttribute('data-placed', '1');
    });
  }

  function open(m) { m.removeAttribute('hidden'); document.documentElement.style.overflow = 'hidden'; }
  function close(m) { m.setAttribute('hidden', ''); document.documentElement.style.overflow = ''; }

  document.addEventListener('click', function (e) {
    var o = e.target.closest && e.target.closest('[data-mk-sc-open]');
    if (o) {
      e.preventDefault();
      var m = document.querySelector('body > [data-mk-sc-modal]') || document.querySelector('[data-mk-sc-modal]');
      if (m) open(m);
      return;
    }
    var c = e.target.closest && e.target.closest('[data-mk-sc-close]');
    if (c) {
      var m2 = c.closest('[data-mk-sc-modal]');
      if (m2) close(m2);
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-mk-sc-modal]:not([hidden])').forEach(close);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', place);
  else place();
  [200, 700, 1500].forEach(function (t) { setTimeout(place, t); });
  document.addEventListener('shopify:section:load', function () { setTimeout(place, 60); });
})();
